<template lang="pug">
	.appraiser
		appraiser-form(
			v-if="!technicalError && !results", 
			:init-data="initData", 
			:type="type", 
			:captcha-img="captchaImg", 
			:settlements="settlements", 
			:contact-data-management-document-url="contactDataManagementDocumentUrl", 
			:appraisal-data-management-document-url="appraisalDataManagementDocumentUrl", 
			:personalized-offer-data-management-document-url="personalizedOfferDataManagementDocumentUrl", 
			:personalized-offer-data-protection-document-url="personalizedOfferDataProtectionDocumentUrl", 
			:submit-state="submitState", 
			:zip-search-state="zipSearchState", 
			:captcha-error="captchaError", 
			:gtm-page-init-form="gtmPageInitForm", 
			:gtm-page-init-prefix="gtmPageInitPrefix", 
			@on-zip-change="getSettlements", 
			@on-submit="send"
		)
		appraiser-technical-error(v-if="technicalError")
		appraiser-results(v-if="results", :results="results", :type="type", :gtm-page-init-result="gtmPageInitResult", :gtm-page-init-prefix="gtmPageInitPrefix")
			template(slot="result-footer-content-customer")
				slot(name="result-footer-content-customer")
			template(slot="result-footer-content-vendor")
				slot(name="result-footer-content-vendor")
</template>

<script>
import { FORM_TYPES, LOADING_STATES } from '../common/constants';
import AppraiserForm from './AppraiserForm';
import AppraiserResults from './AppraiserResults';
import AppraiserTechnicalError from './AppraiserTechnicalError';
import appraiserApi from '../api/appraiser-api';

export default {
	name: 'Appraiser',
	data: () => ({
		initData: null,
		settlements: null,
		submitState: LOADING_STATES.IDLE,
		zipSearchState: LOADING_STATES.IDLE,
		captchaKey: null,
		captchaImg: null,
		captchaError: false,
		technicalError: false,
		results: null
	}),
	props: {
		type: {
			required: true,
			validator(val) {
				return Object.values(FORM_TYPES).includes(val);
			}
		},
		contactDataManagementDocumentUrl: {
			required: true,
			type: String
		},
		appraisalDataManagementDocumentUrl: {
			required: true,
			type: String
		},
		personalizedOfferDataManagementDocumentUrl: {
			required: true,
			type: String
		},
		personalizedOfferDataProtectionDocumentUrl: {
			required: true,
			type: String
		},
		gtmPageInitPrefix: {
			type: String
		},
		gtmPageInitForm: {
			type: String
		},
		gtmPageInitResult: {
			type: String
		}
	},
	components: {
		AppraiserForm,
		AppraiserResults,
		AppraiserTechnicalError
	},
	methods: {
		async init() {
			try {
				const response = await appraiserApi.init();
				this.initData = response.data;
				this.captchaKey = response.data.captchaKey;
				if (response.data.captcha && response.data.captcha.htmlFragment) {
					this.captchaImg = response.data.captcha.htmlFragment;
				}
			} catch (err) {
				this.technicalError = true;
			}
		},
		async refreshCaptcha() {
			const captchaResponse = await appraiserApi.getCaptcha();
			this.captchaKey = captchaResponse.data.captchaKey;
			if (captchaResponse.data.captcha && captchaResponse.data.captcha.htmlFragment) {
				this.captchaImg = captchaResponse.data.captcha.htmlFragment;
			}
		},
		sendSubmitGTM(valuationSubmitResult) {
			this.$gtm.trackEvent({
				event: 'valuationSubmit',
				valuationSubmitResult
			});
		},
		async send(params) {
			try {
				this.captchaError = false;
				this.technicalError = false;
				this.submitState = LOADING_STATES.IN_PROGRESS;
				const sentModel = Object.assign({}, params, { captchaKey: this.captchaKey, url: window.location.href });
				const response = await appraiserApi.send(this.type, sentModel);
				this.results = response.data;
				this.sendResultChangeEvent({ detail: { email: params.email, hasCouponCode: false } });
				this.sendSubmitGTM('Sikeres');
			} catch (err) {
				if (err.response.status == 400 && err.response.data && err.response.data.status == 400) {
					this.captchaError = true;
					this.refreshCaptcha();
				} else {
					this.sendSubmitGTM('Sikertelen');
					this.technicalError = true;
				}
			} finally {
				this.submitState = LOADING_STATES.IDLE;
			}
		},
		sendResultChangeEvent(result) {
			const event = new CustomEvent('result-change', result);
			window.dispatchEvent(event);
		},
		async getSettlements(zipCode) {
			try {
				this.zipSearchState = LOADING_STATES.IN_PROGRESS;
				this.technicalError = false;
				const response = await appraiserApi.getSettlements(zipCode);
				this.zipSearchState = LOADING_STATES.IDLE;
				this.settlements = response.data;
			} catch (err) {
				this.technicalError = true;
			}
		}
	},
	created() {
		this.init();
	}
};
</script>

<style src="@ui-common/sf-style-utils/dist/headings.css"></style>
<style src="@ui-common/sf-style-utils/dist/link.css"></style>
<style src="@ui-common/sf-style-utils/dist/hr.css"></style>
<style src="@ui-common/sf-style-utils/dist/paragraph.css"></style>
<style src="@sfui/helpers/_accessibility.scss" lang="scss"></style>
<style lang="scss">
@import '~@sfui/helpers/_variables';
.appraiser {
	font-family: 'Source Sans Pro', sans-serif;
}
</style>
